import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import { useAppDispatch } from "../store/hooks";
import { loginUser, verifyOTP } from "../store/slices/userSlice";

export default function Login() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [otpCode, setOtpCode] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    
    try {
      const result = await dispatch(loginUser(formData));
      
      if (loginUser.fulfilled.match(result)) {
        // OTP gönderildi, OTP ekranını göster
        setShowOTP(true);
        setSuccessMessage(result.payload?.message || "OTP gönderildi. Lütfen email'inizi kontrol edin.");
        // Development'ta OTP response'da dönebilir
        if (result.payload?.data?.otp) {
          setOtpCode(result.payload.data.otp);
        }
      } else {
        // Login başarısız
        setError(result.error?.message || "Giriş başarısız. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();
    setError("");
    
    if (!otpCode || otpCode.length !== 6) {
      setError("Lütfen 6 haneli OTP kodunu girin.");
      return;
    }
    
    try {
      const result = await dispatch(verifyOTP({
        email: formData.email,
        otp: otpCode,
        purpose: "login"
      }));
      
      if (verifyOTP.fulfilled.match(result)) {
        // OTP doğrulandı, dashboard'a yönlendir
        navigate("/dashboard");
      } else {
        // OTP doğrulama başarısız
        setError(result.error?.message || "OTP doğrulama başarısız. Lütfen tekrar deneyin.");
      }
    } catch (err) {
      setError("Bir hata oluştu. Lütfen tekrar deneyin.");
    }
  };

  const handleBackToLogin = () => {
    setShowOTP(false);
    setOtpCode("");
    setError("");
    setSuccessMessage("");
  };

  return (
    <div className="login-container">
      <div className="login-card">
        {!showOTP ? (
          <>
            <div className="login-header">
              <h1>Giriş Yap</h1>
              <p>Hesabınıza giriş yapın</p>
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {error && (
                <div style={{ 
                  color: "#e53e3e", 
                  backgroundColor: "#fed7d7", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  marginBottom: "16px",
                  fontSize: "14px"
                }}>
                  {error}
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="email">E-posta</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ornek@email.com"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Şifre</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="••••••••"
                  required
                />
              </div>

              <div className="form-options">
                <label className="remember-me">
                  <input type="checkbox" />
                  <span>Beni hatırla</span>
                </label>
                <a href="#" className="forgot-password">
                  Şifremi unuttum
                </a>
              </div>

              <button type="submit" className="login-button">
                Giriş Yap
              </button>

              <div className="register-link">
                <p>
                  Hesabınız yok mu? <Link to="/register">Kayıt ol</Link>
                </p>
              </div>
            </form>
          </>
        ) : (
          <>
            <div className="login-header">
              <h1>OTP Doğrulama</h1>
              <p>Email'inize gönderilen OTP kodunu girin</p>
            </div>

            <form onSubmit={handleOTPSubmit} className="login-form">
              {successMessage && (
                <div style={{ 
                  color: "#22543d", 
                  backgroundColor: "#c6f6d5", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  marginBottom: "16px",
                  fontSize: "14px"
                }}>
                  {successMessage}
                </div>
              )}
              
              {error && (
                <div style={{ 
                  color: "#e53e3e", 
                  backgroundColor: "#fed7d7", 
                  padding: "12px", 
                  borderRadius: "8px", 
                  marginBottom: "16px",
                  fontSize: "14px"
                }}>
                  {error}
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="otp">OTP Kodu</label>
                <input
                  type="text"
                  id="otp"
                  name="otp"
                  value={otpCode}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                    setOtpCode(value);
                    setError("");
                  }}
                  placeholder="123456"
                  maxLength={6}
                  required
                  style={{ 
                    textAlign: "center", 
                    fontSize: "24px", 
                    letterSpacing: "8px",
                    fontFamily: "monospace"
                  }}
                />
                <p style={{ 
                  fontSize: "12px", 
                  color: "#718096", 
                  marginTop: "8px",
                  textAlign: "center"
                }}>
                  {formData.email} adresine gönderilen 6 haneli kodu girin
                </p>
              </div>

              <button type="submit" className="login-button">
                Doğrula
              </button>

              <button 
                type="button" 
                onClick={handleBackToLogin}
                style={{
                  width: "100%",
                  padding: "12px",
                  marginTop: "12px",
                  backgroundColor: "transparent",
                  color: "#4299e1",
                  border: "1px solid #4299e1",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontSize: "14px"
                }}
              >
                Geri Dön
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
